<template>
  <v-container style="overflow-x:scroll">
    <v-simple-table
      dense
      v-if="tampilTable"
      class="tg"
    >
      <template #default>
        <thead>
          <tr>
            <th class="tg-baqh" />
            <th
              class="tg-baqh text-center"
              colspan="5"
            >
              <span class="text-h6">Wed 22 Apr</span>
            </th>
            <th
              class="tg-baqh text-center"
              colspan="5"
            >
              <span class="text-h6">Thu 24 Apr</span>
            </th>
            <th
              class="tg-baqh text-center"
              colspan="5"
            >
              <span class="text-h6">Fri 25 Apr</span>
            </th>
            <th
              class="tg-baqh text-center"
              colspan="5"
            >
              <span class="text-h6">Sat 26 Apr</span>
            </th>
            <th
              class="tg-baqh text-center"
              colspan="5"
            >
              <span class="text-h6">Sun 27 Apr</span>
            </th>
            <th
              class="tg-baqh text-center"
              colspan="5"
            >
              <span class="text-h6">Mon 28 Apr</span>
            </th>
            <th
              class="tg-baqh text-center"
              colspan="5"
            >
              <span class="text-h6">Tue 29 Apr</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="tg-0lax" />
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Nissan
            </td>
            <td class="tg-0lax">
              Hyundai
            </td>
            <td class="tg-0lax">
              Kia
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Nissan
            </td>
            <td class="tg-0lax">
              Hyundai
            </td>
            <td class="tg-0lax">
              Kia
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Nissan
            </td>
            <td class="tg-0lax">
              Hyundai
            </td>
            <td class="tg-0lax">
              Kia
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Nissan
            </td>
            <td class="tg-0lax">
              Hyundai
            </td>
            <td class="tg-0lax">
              Kia
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Nissan
            </td>
            <td class="tg-0lax">
              Hyundai
            </td>
            <td class="tg-0lax">
              Kia
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Nissan
            </td>
            <td class="tg-0lax">
              Hyundai
            </td>
            <td class="tg-0lax">
              Kia
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
            <td class="tg-0lax">
              Nissan
            </td>
            <td class="tg-0lax">
              Hyundai
            </td>
            <td class="tg-0lax">
              Kia
            </td>
            <td class="tg-0lax">
              Toyota
            </td>
          </tr>
          <tr>
            <td class="tg-0lax" />
            <td class="tg-0lax">
              Camry
            </td>
            <td class="tg-0lax">
              Leaf Hatch
            </td>
            <td class="tg-0lax">
              I20
            </td>
            <td class="tg-0lax">
              Carnival
            </td>
            <td class="tg-0lax">
              Corolla
            </td>
            <td class="tg-0lax">
              Camry
            </td>
            <td class="tg-0lax">
              Leaf Hatch
            </td>
            <td class="tg-0lax">
              I20
            </td>
            <td class="tg-0lax">
              Carnival
            </td>
            <td class="tg-0lax">
              Corolla
            </td>
            <td class="tg-0lax">
              Camry
            </td>
            <td class="tg-0lax">
              Leaf Hatch
            </td>
            <td class="tg-0lax">
              I20
            </td>
            <td class="tg-0lax">
              Carnival
            </td>
            <td class="tg-0lax">
              Corolla
            </td>
            <td class="tg-0lax">
              Camry
            </td>
            <td class="tg-0lax">
              Leaf Hatch
            </td>
            <td class="tg-0lax">
              I20
            </td>
            <td class="tg-0lax">
              Carnival
            </td>
            <td class="tg-0lax">
              Corolla
            </td>
            <td class="tg-0lax">
              Camry
            </td>
            <td class="tg-0lax">
              Leaf Hatch
            </td>
            <td class="tg-0lax">
              I20
            </td>
            <td class="tg-0lax">
              Carnival
            </td>
            <td class="tg-0lax">
              Corolla
            </td>
            <td class="tg-0lax">
              Camry
            </td>
            <td class="tg-0lax">
              Leaf Hatch
            </td>
            <td class="tg-0lax">
              I20
            </td>
            <td class="tg-0lax">
              Carnival
            </td>
            <td class="tg-0lax">
              Corolla
            </td>
            <td class="tg-0lax">
              Camry
            </td>
            <td class="tg-0lax">
              Leaf Hatch
            </td>
            <td class="tg-0lax">
              I20
            </td>
            <td class="tg-0lax">
              Carnival
            </td>
            <td class="tg-0lax">
              Corolla
            </td>
          </tr>
          <tr>
            <td class="tg-0lax" />
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Blue
            </td>
            <td class="tg-0lax">
              Silver
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Black
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Blue
            </td>
            <td class="tg-0lax">
              Silver
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Black
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Blue
            </td>
            <td class="tg-0lax">
              Silver
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Black
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Blue
            </td>
            <td class="tg-0lax">
              Silver
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Black
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Blue
            </td>
            <td class="tg-0lax">
              Silver
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Black
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Blue
            </td>
            <td class="tg-0lax">
              Silver
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Black
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Blue
            </td>
            <td class="tg-0lax">
              Silver
            </td>
            <td class="tg-0lax">
              Red
            </td>
            <td class="tg-0lax">
              Black
            </td>
          </tr>
          <tr>
            <td class="tg-0lax">
              5am
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              6am
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              7am
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              8am
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              9am
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              10am
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              11am
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              12pm
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
          <tr>
            <td class="tg-0lax">
              13pm
            </td>
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
            <td class="tg-0lax" />
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog
      v-model="dialogs.open"
      persistent
      max-width="600px"
      @click:outside="handleClickDialogOutside"
    >
      <v-card>
        <v-card-subtitle>TEST</v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-sheet
      tile
      height="54"
      color="grey lighten-3"
      class="d-flex"
    >
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <h4
        v-if="$refs.calendar"
        class="pa-4"
      >
        {{ $refs.calendar.title }}
      </h4>
      <v-spacer />
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-row class="fill-height">
      <v-col>
        <v-sheet>
          <v-calendar
            ref="calendar"
            color="primary"
            :events="events"
            type="category"
            :category-days="categoryDays"
            :category-show-all="categoryShowAll"
            :category-hide-dynamic="categoryHideDynamic"
            :event-color="getEventColor"
            :event-ripple="false"
            :start="startDate"
            :categories="categories"
            @change="getEvents"
            @click:event="showEvent"
            @mousedown:event="startDrag"
            @mousedown:time-category="startTime"
            @mousemove:time="mouseMove"
            @mouseup:time="endDrag"
            @mouseup:event="endEventSelected"
            @mouseleave.native="cancelDrag"
            :weekday-format="myDayFormat"
          >
            <template #event="{ event, timed, eventSummary }">
              <div
                class="v-event-draggable"
                v-html="eventSummary(event)"
              />
              <div
                v-if="timed"
                class="v-event-drag-bottom"
                @mousedown.stop="extendBottom(event)"
              />
            </template>
            <template #category="{ category }">
              <p
                class="mt-2 ml-2"
                style="font-size: 12px"
              >
                Test{{ category }}
              </p>
            </template>
            <template #day-label-header="{ day }">
              <div>{{ day }}</div>
              <br>
              <v-btn>test</v-btn>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row class="fill-height">
      <v-col>
        <v-sheet height="64">
          <v-toolbar
            flat
          >
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
            >
              Today
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer />
            <v-menu
              bottom
              right
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="eventss"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          />
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
            class="ma-5"
          >
            <v-card
              color="white lighten-4"
              flat
              max-width="550"
            >
              <v-toolbar
                color="grey lighten-3"
                dense
                elevation="0"
                max-width="550"
              >
                <v-toolbar-title v-html="selectedEvent.name" />
                <v-spacer />
                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="ma-0">
                <v-list>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="pa-0 mr-4">
                      <v-icon
                        color="indigo"
                        dense
                      >
                        mdi-map-marker
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title style="font-size: 14px; font-weight: 400;">
                        From <b> Jakarta </b> to <b> Bandung </b>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="pa-0 mr-4">
                      <v-icon
                        color="indigo"
                        dense
                      >
                        mdi-clock-time-four-outline
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="mx-0">
                      <v-list-item-title style="font-size: 14px; font-weight: 400;">
                        Monday, 5 April
                      </v-list-item-title>
                      <v-list-item-subtitle>05:30 - 07:00</v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-row>
                          <v-col
                            sm="4"
                            md="4"
                            class="py-0 mr-2"
                          >
                            <v-checkbox
                              v-model="onedayBooking"
                              label="One Day Booking"
                              hide-details
                              dense
                            />
                          </v-col>
                          <v-col
                            sm="6"
                            md="6"
                            v-if="!onedayBooking"
                          >
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              max-width="290"
                            >
                              <template #activator="{ on, attrs }">
                                <v-text-field
                                  :value="computedDateFormattedMomentjs"
                                  clearable
                                  filled
                                  dense
                                  hide-details
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  @click:clear="date = null"
                                />
                              </template>
                              <v-date-picker
                                v-model="date"
                                @change="menu1 = false"
                              />
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="!onedayBooking">
                        <v-select
                          :items="items"
                          filled
                          hide-details
                          label="Recurring Booking"
                          dense
                        />
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        <v-radio-group 
                          v-model="radios"
                          v-if="!onedayBooking"
                          class="mt-0 pt-0"
                        >
                          <v-radio
                            value="endAfter"
                            class="mt-0 pt-0"
                          >
                            <template #label>
                              <v-row>
                                <v-col
                                  cols="3"
                                  md="3"
                                  class="mt-3"
                                >
                                  <span>End After:</span>
                                </v-col>
                                <v-col
                                  cols="6"
                                  md="6"
                                  class="pt-0"
                                >
                                  <v-select
                                    v-if="!onedayBooking"
                                    :items="recurringEnds"
                                    class="mt-4"
                                    outlined
                                    item-value="1"
                                    hide-details
                                    dense
                                  >
                                    <template #label>
                                      <span>End After</span>
                                    </template>
                                  </v-select>
                                </v-col>
                                <v-col
                                  cols="3"
                                  md="3"
                                  class="mt-6"
                                >
                                  <strong>occurance(s)</strong>
                                </v-col>
                              </v-row>
                            </template>
                          </v-radio>
                          <v-radio value="endBy">
                            <template #label>
                              <v-row class="mt-0 pt-0">
                                <v-col
                                  cols="3"
                                  md="3"
                                  class="mt-3"
                                >
                                  <span>End By:</span>
                                </v-col>
                                <v-col
                                  cols="6"
                                  md="6"
                                  class="pt-0"
                                >
                                  <v-select
                                    v-if="!onedayBooking"
                                    :items="recurringEnds"
                                    class="mt-4"
                                    outlined
                                    item-value="1"
                                    hide-details
                                    dense
                                  >
                                    <template #label>
                                      <span>End After</span>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="pa-0 mr-4">
                      <v-icon
                        color="indigo"
                        dense
                      >
                        mdi-car
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title style="font-size: 14px; font-weight: 400;">
                        Pool Vehicle
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="pa-0 mr-4">
                      <v-icon
                        color="indigo"
                        dense
                      >
                        mdi-car-side
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="mx-0">
                      <v-list-item-title style="font-size: 14px; font-weight: 400;">
                        7-8 Seat Family Car
                      </v-list-item-title>
                      <v-list-item-subtitle>Toyota Yaris 1234B</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-icon class="pa-0 mr-4">
                      <v-icon
                        color="indigo"
                        dense
                      >
                        mdi-account-multiple
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="mx-0">
                      <v-list-item-title style="font-size: 14px; font-weight: 400;">
                        <v-row class="pa-0">
                          <v-col
                            sm="3"
                            md="3"
                            class="py-0"
                          >
                            <v-text-field
                              filled
                              dense
                              type="number"
                              value="1"
                              min="1"
                            />
                          </v-col>
                          <v-col>
                            Passenger
                          </v-col>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  text
                  color="secondary"
                  @click="selectedOpen = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      // value: '',
      date: "2021-04-06",
      menu1: false,
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      events: [],
      eventss: [],
      radios: 'endAfter',
      colors: ['#2196F3', '#3F51B5', '#673AB7', '#00BCD4', '#4CAF50', '#FF9800', '#757575'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
      categories: ['Toyota Camry', 'Honda Jazz', 'Mini Cooper'],
      categoryShowAll: true,
      categoryHideDynamic: false,
      categoryDays: 4,
      dragEvent: null,
      startDate: "2021-04-04",
      tampilTable: false,
      // today: '2021-04-10',
      createEvent: null,
      createStart: null,
      extendOriginal: null,
      onedayBooking: true,
       focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      dialogs: {
        open: false,
        data: {},
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      keepSilent: false,
      handleSilent: null
    };
  },
   computed: {
    computedDateFormattedMomentjs () {
      return this.date ? moment(this.date).format('dddd, MMMM Do') : ''
    },
  },
  methods: {
    myDayFormat(day) {
			return "POOP";
		},
    updateRange ({ start, end }) {
      const events = []

      const min = new Date(`${start.date}T00:00:00`)
      const max = new Date(`${end.date}T23:59:59`)
      const days = (max.getTime() - min.getTime()) / 86400000
      const eventCount = this.rnd(days, days + 20)

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0
        const firstTimestamp = this.rnd(min.getTime(), max.getTime())
        const first = new Date(firstTimestamp - (firstTimestamp % 900000))
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
        const second = new Date(first.getTime() + secondTimestamp)

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        })
      }

      this.eventss = events
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    prev () {
        this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        
        this.selectedElement = nativeEvent.target
        
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    handleClickDialogOutside() {
      this.dialogs.open = false;
    },
    startDrag ({ event, timed }) {
      
      if (event.hasOwnProperty('id')) {
        this.keepSilent = true;
        this.handleSilent = setTimeout(() => {
          this.keepSilent = false;
        }, 1e3);
        return;
      }

      if (event && timed) {
        
        this.dragEvent = event
        this.dragTime = null
        this.extendOriginal = null
      } else if (event === null) {
        
      }
    },
    startTime (tms) {
      
      const mouse = this.toTime(tms)
      if (this.dragEvent && this.dragTime === null) {
        const start = this.dragEvent.start
        this.dragTime = mouse - start
      } else {
        if (this.keepSilent) return;
        this.createStart = this.roundTime(mouse)
        this.createEvent = {
          name: `Event #${this.events.length}`,
          color: this.rndElement(this.colors),
          start: this.createStart,
          end: this.createStart,
          timed: true,
          category: tms.category
        }
        this.events.push(this.createEvent)
      }
    },
    extendBottom (event) {
      if (event.hasOwnProperty('id')) {
        this.keepSilent = true;
        this.handleSilent = setTimeout(() => {
          this.keepSilent = false;
        }, 1e3);
        return;
      }
      
      this.createEvent = event
      this.createStart = event.start
      this.extendOriginal = event.end
    },
    mouseMove (tms) {
      const mouse = this.toTime(tms)
      
      if (this.dragEvent && this.dragTime !== null) {
        const start = this.dragEvent.start
        const end = this.dragEvent.end
        const duration = end - start
        const newStartTime = mouse - this.dragTime
        const newStart = this.roundTime(newStartTime)
        const newEnd = newStart + duration

        this.dragEvent.start = newStart
        this.dragEvent.end = newEnd
      } else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStart)
        const max = Math.max(mouseRounded, this.createStart)

        this.createEvent.start = min
        this.createEvent.end = max
      }
    },
    endDrag () {
      this.dragTime = null
      this.dragEvent = null
      this.createEvent = null
      this.createStart = null
      this.extendOriginal = null
    },
    endEventSelected(e) {
      this.createEvent = {
          name: `Event #${this.events.length}`,
          color: this.rndElement(this.colors),
          start: this.createStart,
          end: this.createStart,
          timed: true,
          category: e.eventParsed.category
        }
         this.dragTime = null
      this.dragEvent = null
      this.createEvent = null
      this.createStart = null
      this.extendOriginal = null
      this.showEvent(e)
    },
    cancelDrag () {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.end = this.extendOriginal
        } else {
          const i = this.events.indexOf(this.createEvent)
          if (i !== -1) {
            this.events.splice(i, 1)
          }
        }
      }

      this.createEvent = null
      this.createStart = null
      this.dragTime = null
      this.dragEvent = null
    },
    roundTime (time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
        ? time - time % roundDownTime
        : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.dragEvent
        ? `rgba(${r}, ${g}, ${b}, 0.7)`
        : event === this.createEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event.color
    },
    getEvents ({ start, end }) {
       const events = [
          {
            category: "Honda Jazz",
            color: "orange",
            name: "Event Test",
            start: new Date("2021-04-04 09:30:00").getTime(),
            end: new Date("2021-04-04 10:30:00").getTime(),
            timed: true,
            id: 1
          },
          {
            category: "Toyota Yaris",
            color: "green",
            name: "Event Test",
            start: new Date("2021-04-05 10:00:00").getTime(),
            end: new Date("2021-04-05 12:00:00").getTime(),
            timed: true,
            id: 2
          },
        ]
      this.events = events
    },
    rndElement (arr) {
      return arr[this.rnd(0, arr.length - 1)]
    },
  },
};
</script>
<style type="text/css">
.v-menu__content {
  margin-left: 20px;
}
.tg {
  border-collapse: collapse;
  border-spacing: 0;
  margin-top: 30px;
}
.tg td {
  border-color: grey;
  border-style: ridge;
  border-width: 0.2px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  overflow: hidden;
  padding: 10px 5px;
  word-break: normal;
}
.tg th {
  border-color: black;
  border-style:ridge;
  border-width: 0.2px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;
  padding: 10px 5px 1px 5px;
  word-break: normal;
}
.tg .tg-baqh {
  text-align: center;
  vertical-align: top;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}

</style>
<style lang="scss">
  .v-event-draggable {
    padding-left: 6px;
  }

  .v-event-timed {
    user-select: none;
    -webkit-user-select: none;
  }

  .v-event-drag-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 4px;
    height: 4px;
    cursor: ns-resize;

    &::after {
      display: none;
      position: absolute;
      left: 50%;
      height: 4px;
      border-top: 1px solid white;
      border-bottom: 1px solid white;
      width: 16px;
      margin-left: -8px;
      opacity: 0.8;
      content: '';
    }

    &:hover::after {
      display: block;
    }
}
</style>
